import { Component, Input } from '@angular/core';
import { EntityType } from '@shared/models/entity-enum';
import { DataObject } from 'projects/miq/report-export-view/src/lib/models/report.model';

export interface AlertListErrorData {
  entity?: EntityType;
  linkEntityTargetType?: EntityType;
  errorMap?: DataObject;
}

@Component({
  selector: 'miq-alert-list-records',
  templateUrl: './alert-list-records.component.html',
  styleUrls: ['./alert-list-records.component.scss'],
  standalone: false,
})
export class AlertListRecordsComponent {
  @Input() alertList: AlertListErrorData[];
}
